import alertMessage from './alertMessage.vue'
export default alertMessage
